// Конфигурация из переменных окружения
export const isValidDomain = (domain): domain is string => {
  return typeof domain === 'string' && domain.length > 0
}

/**
 * @param {string} str - список доментов: a.com;b.com;c.com
 */
export const parseDomains = (str?: string): string[] => {
  if (str == null) {
    return []
  }

  return str.split(';').filter(isValidDomain)
}

/**
 * Возвращает доменную зону хоста (домен 2-го уровня).
 * Функция чистая (без window) — безопасна и на сервере, и на клиенте.
 *
 * site.brand.test - brand.test
 * mktu.site.com   - site.com
 * localhost       - localhost
 *
 * Ограничение: правило «последние две метки» не знает составных public suffix
 * (напр. co.uk) — для доменов проекта (io, com, ru) корректно.
 *
 * @param {string} host - имя хоста без схемы и порта (напр. site.brand.test)
 */
export const getDomainZone = (host: string): string => {
  const normalizedHost = host.trim().toLowerCase().split(':')[0]

  if (normalizedHost === '') {
    return ''
  }

  const labels = normalizedHost.split('.')

  if (labels.length <= 2) {
    return normalizedHost
  }

  return labels.slice(-2).join('.')
}
